(() => {
  if (window.__lbOrderOfferV1) return;
  window.__lbOrderOfferV1 = true;
  const selector = 'input[data-lb-order-offer]';
  const property = 'properties[_lb_delivery_offer]';
  const watched = new WeakSet();
  let queued = false;

  function visible(hint) {
    if (!hint || hint.hidden || !hint.textContent.trim() || hint.closest('[aria-hidden="true"]')) return false;
    const style = getComputedStyle(hint);
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      Array.from(hint.getClientRects()).some(r => r.width > 0 && r.height > 0);
  }

  function resolve(form) {
    try {
      const action = new URL(form.action, location.href);
      if (action.origin !== location.origin || !/\/cart\/add\/?$/.test(action.pathname)) return 'v1:unknown';
      const section = form.closest('.product-section');
      const hint = section && section.querySelector('[data-lb-stock-hint][data-lb-vb-ids]');
      if (!visible(hint)) return 'v1:unknown';
      const select = form.elements.namedItem('id');
      const id = String(select?.value || '');
      if (!/^\d+$/.test(id)) return 'v1:unknown';
      if (!(select instanceof HTMLSelectElement) || !Array.from(select.options).some(o => o.value === id && !o.disabled)) return 'v1:unknown';
      const quantityField = form.elements.namedItem('quantity');
      const quantity = Number(quantityField ? quantityField.value : 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return 'v1:unknown';
      const preorder = hint.getAttribute('data-lb-vb-ids').split(',').includes(id);
      if (preorder !== hint.classList.contains('lb-product-delivery--vorbestellung')) return 'v1:unknown';
      if (!preorder && quantity !== 1) return 'v1:unknown';
      return `v1:${preorder ? 'preorder' : 'regular'}:${id}`;
    } catch (_) {
      return 'v1:unknown';
    }
  }

  function sync(form, data) {
    if (!form || !form.querySelector(selector)) return;
    const value = resolve(form);
    form.querySelectorAll(selector).forEach(field => {
      if (field.value !== value) field.value = value;
      if (field.getAttribute('value') !== value) field.setAttribute('value', value);
    });
    if (data && typeof data.set === 'function') data.set(property, value);
  }

  function syncAll() {
    const forms = new Set();
    document.querySelectorAll(selector).forEach(field => { if (field.form) forms.add(field.form); });
    forms.forEach(form => {
      sync(form);
      const hint = form.closest('.product-section')?.querySelector('[data-lb-stock-hint]');
      if (hint && !watched.has(hint)) {
        watched.add(hint);
        hintObserver.observe(hint, { attributes: true, childList: true, subtree: true,
          attributeFilter: ['class', 'hidden', 'data-lb-vb-ids'] });
      }
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; syncAll(); });
  }

  const hintObserver = new MutationObserver(schedule);
  const treeObserver = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))))) schedule();
  });
  treeObserver.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('submit', event => sync(event.target), true);
  document.addEventListener('formdata', event => sync(event.target, event.formData), true);
  document.addEventListener('change', event => sync(event.target.form || event.target.closest?.('form')), true);
  document.addEventListener('input', event => {
    if (event.target.matches?.('[name="quantity"], [name="id"]')) sync(event.target.form || event.target.closest?.('form'));
  }, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('product-form:submit:before', event => {
    const form = event.target.matches?.('form') ? event.target : event.target.querySelector?.('form');
    sync(form, event.detail?.form);
  });
  document.addEventListener('pointerdown', event => {
    const form = event.target.closest?.('form');
    if (form) sync(form);
  }, true);
  window.addEventListener('resize', schedule, { passive: true });
  syncAll();
})();
